import {buildRRTab} from './current-rr-tab/index';
import propertyInformationTab from './property-information-tab/index';
import pricingTab from './pricing-tab/index';
import expensesTab from './expenses-tab/index';
import marketingTab from './marketing-tab/index';
import {buildReimbTab} from './current-reimbursement-tab/index';

export default {
    'marketing-tab': marketingTab,
    'property-information-tab': propertyInformationTab,
    'pricing-tab': pricingTab,
    'current-rr-tab': buildRRTab('current-rr-tab'),
    'current-reimbursement-tab': buildReimbTab('current-reimbursement-tab'),
    'expenses-tab': expensesTab,
    'proforma-rr-tab': buildRRTab('proforma-rr-tab'),
    'proforma-reimbursement-tab': buildReimbTab('proforma-reimbursement-tab'),
};